import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import chooseSeasonTabRouter from "./chooseSeasonTabRouter";

function ChooseSeasonTab(props) {

  return (
    <TabTemplate 
      router={chooseSeasonTabRouter}
      passData={props.passData}
    />
  )

}

export default ChooseSeasonTab;